export const PLACEHOLDER_OPEN = '[[[';
export const PLACEHOLDER_CLOSE = ']]]';

/** Toolkit prompts mark the details a user should fill in as `[[[e.g. the date range]]]`. */
const PLACEHOLDER_PATTERN = /\[\[\[([\s\S]*?)\]\]\]/g;

export interface PromptPlaceholder {
  /** Index of the opening brackets. */
  start: number;
  /** Index just past the closing brackets. */
  end: number;
  /** The hint between the brackets. */
  text: string;
}

export const findPromptPlaceholders = (prompt: string): PromptPlaceholder[] =>
  Array.from(prompt.matchAll(PLACEHOLDER_PATTERN), (match) => ({
    start: match.index,
    end: match.index + match[0].length,
    text: match[1],
  }));
